"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _ScreenPlaceholder = require("../../molecules/ScreenPlaceholder");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ChatListUserNotLogged = function ChatListUserNotLogged(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenPlaceholder.ScreenPlaceholder, {
    title: "Usu\xE1rio Deslogado",
    text: "Para enviar mensagens, \xE9 preciso estar logado na sua conta.",
    cta: "Acessar / Criar Conta",
    action: onClick
  });
};
ChatListUserNotLogged.propTypes = {
  onClick: _propTypes.func.isRequired
};
var _default = exports["default"] = ChatListUserNotLogged;